import { formatAddress } from '@utils/address'
import { useMemo } from 'react'
import { Address } from 'types/common'

export function useGoogleMapsLink(fullAddress?: Address) {
  return useMemo(() => {
    if (!fullAddress) return null
    const gmapsUrl = new URL('https://www.google.com/maps')

    // Check if new format fields exist (number, street, etc.)
    const hasNewFormat = fullAddress.number || fullAddress.street

    let addressString: string
    if (hasNewFormat) {
      // New format: number + street + city + administrativeArea + postalCode
      addressString = formatAddress(fullAddress)
    } else {
      // Old format: address + city + state + zip
      const parts = [
        fullAddress.address,
        fullAddress.city,
        fullAddress.state,
        fullAddress.zip || fullAddress.postalCode, // Support both zip and postalCode for old format
      ].filter(Boolean) // Remove undefined/null/empty values
      addressString = parts.join(' ')
    }

    // Replace spaces with + for URL encoding
    addressString = addressString.split(' ').join('+')
    gmapsUrl.searchParams.set('q', addressString)
    return gmapsUrl.href
  }, [fullAddress])
}
